import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import { StaticImage } from 'gatsby-plugin-image';

import './style.scss';

const RoleSection = () => {
  return (
    <section className="l-role">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
      </Parallax>
      <div className="container">
        <h2 className="section-title">Role of the Councils</h2>

        <div className="grid">
          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-content">
              <strong>Enable creation of professional standards schemes</strong> that limit the civil liability of
              professionals and others
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-content">
              <strong>Supervising the operation</strong> of professional standards schemes by occupational associations
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-content">
              <strong>Monitoring how well occupational associations and their members</strong> meet the standards
              demanded by their professional standards schemes
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-content">
              <strong>Encouraging and assisting</strong> professional standards regulation by occupational association
            </div>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="card-content">
              <strong>Ensuring protection of consumers</strong> who use the services provided by professionals and
              others through <strong>insurance, complaints and disciplinary arrangements</strong>
            </div>
          </div>

          <div
            className="image"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <StaticImage
              src="./assets/council-photo.jpg"
              alt="Professional Standards Councils’ meeting in Sydney"
              quality={100}
              layout="fullWidth"
              objectFit="cover"
              />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoleSection;
